import {IconBox, Typography} from '@sollapay/ui/components';

import type {IconBoxTone, IconName} from '@sollapay/ui/components';
import type {FC} from 'react';

export interface ActivationMetaItemProps {
  icon: IconName;
  label: string;
  value: string;
  tone?: IconBoxTone;
}

/** Round icon beside a small muted label stacked over a semibold value. */
export const ActivationMetaItem: FC<ActivationMetaItemProps> = ({
  icon,
  label,
  value,
  tone = 'brand'
}) => (
  <div data-slot="activation-meta-item" className="flex shrink-0 items-center gap-3">
    <IconBox icon={icon} tone={tone} shape="round" />
    <div className="flex flex-col gap-0.5">
      <Typography as="span" size="sm" color="tertiary">
        {label}
      </Typography>
      <Typography as="span" weight="semibold">
        {value}
      </Typography>
    </div>
  </div>
);
